import { View, Text } from "react-native";
import Svg, { Path, Circle } from "react-native-svg";

interface Slice { key: string; value: number }
interface Props {
  title: string;
  data: Slice[];
  size?: number;
}

const COLORS = ["#3B82F6", "#F5A623", "#10B981", "#A855F7", "#EF4444", "#06B6D4", "#F472B6", "#84CC16", "#6366F1", "#FB923C"];

export function PieChart({ title, data, size = 160 }: Props) {
  const total = data.reduce((s, d) => s + d.value, 0);
  const r = size / 2;
  const cx = r;
  const cy = r;

  let cumulative = 0;
  const slices = data.map((d, i) => {
    const startAngle = (cumulative / total) * 2 * Math.PI;
    cumulative += d.value;
    const endAngle = (cumulative / total) * 2 * Math.PI;
    const largeArc = endAngle - startAngle > Math.PI ? 1 : 0;
    const x1 = cx + r * Math.sin(startAngle);
    const y1 = cy - r * Math.cos(startAngle);
    const x2 = cx + r * Math.sin(endAngle);
    const y2 = cy - r * Math.cos(endAngle);
    const path = `M ${cx},${cy} L ${x1},${y1} A ${r},${r} 0 ${largeArc} 1 ${x2},${y2} Z`;
    return { ...d, path, color: COLORS[i % COLORS.length], pct: total > 0 ? (d.value / total) * 100 : 0 };
  });

  return (
    <View style={{ flex: 1 }}>
      <Text style={{ fontSize: 12, fontWeight: "700", color: "#6b7280", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 10 }}>{title}</Text>
      {total === 0 ? (
        <Text style={{ fontSize: 12, color: "#9ca3af", paddingVertical: 24, textAlign: "center" }}>No data</Text>
      ) : (
        <View style={{ flexDirection: "row", alignItems: "center", gap: 14 }}>
          <Svg width={size} height={size}>
            {slices.length === 1 ? (
              <Circle cx={cx} cy={cy} r={r} fill={slices[0].color} />
            ) : (
              slices.map((s, i) => <Path key={i} d={s.path} fill={s.color} stroke="#fff" strokeWidth={1} />)
            )}
          </Svg>
          <View style={{ flex: 1 }}>
            {slices.map((s, i) => (
              <View key={i} style={{ flexDirection: "row", alignItems: "center", paddingVertical: 3 }}>
                <View style={{ width: 10, height: 10, borderRadius: 2, backgroundColor: s.color, marginRight: 6 }} />
                <Text style={{ flex: 1, fontSize: 11, color: "#374151" }} numberOfLines={1}>{s.key}</Text>
                <Text style={{ fontSize: 11, fontWeight: "700", color: "#1B2A4A", marginLeft: 4 }}>{s.pct.toFixed(0)}%</Text>
              </View>
            ))}
          </View>
        </View>
      )}
    </View>
  );
}
